import { useEffect } from "react";
import Lenis from "lenis";
import "@/App.css";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import ComparisonTable from "@/components/landing/ComparisonTable";
import FeatureShowdown from "@/components/landing/FeatureShowdown";
import Metrics from "@/components/landing/Metrics";
import Verdict from "@/components/landing/Verdict";
import Footer from "@/components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.14, smoothWheel: true, wheelMultiplier: 1.05 });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App relative min-h-screen bg-[#050505] text-slate-200">
      <div className="noise-layer pointer-events-none fixed inset-0 z-[60] opacity-[0.035]" />
      <div className="pointer-events-none fixed inset-0 z-0 overflow-hidden">
        <div className="absolute left-1/2 top-[-320px] h-[640px] w-[900px] -translate-x-1/2 rounded-full bg-[#3B82F6]/[0.05] blur-[140px]" />
        <div className="absolute right-[-200px] top-[40%] h-[420px] w-[420px] rounded-full bg-[#22D3EE]/[0.03] blur-[120px]" />
        <div className="absolute bottom-[-160px] left-[-180px] h-[420px] w-[420px] rounded-full bg-[#6366F1]/[0.035] blur-[120px]" />
      </div>
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <ComparisonTable />
        <Metrics />
        <FeatureShowdown />
        <Verdict />
      </main>
      <Footer />
    </div>
  );
}

export default App;
